import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useFormContext, Controller } from 'react-hook-form';
import FormIcon from './FormIcon';

export default function FormDropDown({
  name,
  menu_items,
  icon,
  label,
  isOpenForm,
  handleFocus,
  isRequired,
}) {
  const formContext = useFormContext();
  const error = formContext.formState.errors[name]?.message;

  return (
    <Controller
      name={name}
      render={({ field: { onChange, onBlur, value, ref } }) => {
        return (
          <TextField
            value={value}
            required={isRequired}
            select
            variant="filled"
            defaultValue=""
            onFocus={handleFocus}
            name={name}
            label={label}
            helperText={error}
            onBlur={onBlur}
            ref={ref}
            onChange={onChange}
            fullWidth
            InputProps={{
              disableUnderline: true,
              style: error
                ? { color: '#ff0000', backgroundColor: '#ff0000' }
                : {
                    color: '#525252',
                    borderRadius: '16px',
                    border: '1px solid #7A8B87',
                    padding: 3,
                    textAlign: 'left',
                    fontFamily: 'Rubik',
                    backgroundColor: '#FFFFFF',
                  },
            }}
            InputLabelProps={{
              style: {
                ...(error
                  ? { color: '#ff0000' }
                  : {
                      color: '#7A8B87',
                      fontWeight: '500',
                      fontSize: '12px',
                      fontFamily: 'Rubik',
                      paddingTop: '5px',
                    }),
              },
            }}
            FormHelperTextProps={{
              style: {
                color: '#FFFFFF',
              },
            }}
            className={`${
              error
                ? 'bg-v5-red-300'
                : isOpenForm
                ? 'bg-v5-green-700'
                : 'bg-v5-green-500'
            } rounded-2xl text-v5-neutral-200`}
            inputProps={{
              'aria-label': `Enter ${label}`,
            }}
            SelectProps={{
              IconComponent: () => (
                <FormIcon
                  icon={icon}
                  error={error}
                  validated={
                    formContext.formState.dirtyFields[name] &&
                    !formContext.formState.errors[name]
                  }
                  className="p-3"
                />
              ),
              MenuProps: {
                PaperProps: {
                  style: {
                    borderBottomRightRadius: 16,
                    borderBottomLeftRadius: 16,
                    maxHeight: '140px',
                    borderBottom: '12px',
                    borderRadius: '12px',
                    marginTop: 1,
                    zIndex: 1,
                  },
                  sx: {
                    bgcolor: '#F2FBF7',
                    color: '#525252',
                    '&::-webkit-scrollbar': {
                      width: 24,
                      borderRadius: '12px',
                    },
                    '&::-webkit-scrollbar-track': {
                      backgroundColor: '#D3E4E0',
                      borderRadius: '12px',
                      border: `4px solid #D3E4E0`,
                      backgroundClip: 'content-box',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#AEC5C0',
                      borderRadius: 1000,
                      // border: '4px solid #AEC5C0',
                      height: 24,
                      width: 24,
                    },
                  },
                },
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
              },
            }}
          >
            {menu_items.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        );
      }}
    ></Controller>
  );
}
